import { defineMessages } from "react-intl";

const messages = defineMessages({
    loading: {
        id: "general.loading",
    },
    editScore: {
        id: "tasks.melodyTable.editScore",
    },
    stopEdit: {
        id: "tasks.stopEdit",
    },
    tempo: {
        id: "tasks.tempo",
    },
    firstKnown: {
        id: "tasks.melodyTable.firstKnown",
    },
    scaling: {
        id: "tasks.rhythmSorting.scaling",
    },
    width: {
        id: "tasks.melodyTable.width",
    },
    height: {
        id: "tasks.melodyTable.height",
    },
    scores: {
        id: "plan.scores",
    },
});

export default messages;
